export class NotificationAttributeDto {
  notificationAttributeId: string;
  notificationAttributeName: string;
  notificationAttributeValue: string;

  constructor(init?: Partial<NotificationAttributeDto>) {
    Object.assign(this, init);
  }
}
